import { get, postJson } from '../../common/data/common-data-service';

export const login = async (email: string, password: string) => {
    return await postJson('/api/membership/login', {
        email,
        password,
    });
};

export const loginDoubleOptIn = async (code: string) => {
    return await postJson('/api/membership/login-opt-in', {
        code,
    });
};

export const logout = async () => {
    return await get('/api/membership/logout');
};

export const getAuthStatus = async () => {
    return await get('/api/membership/auth-status');
};

export const getMe = async () => {
    try{
        const rawResponse = await fetch('/api/membership/users/me', {
            method: 'GET',
            credentials: 'include', // send cookie
            headers: {
                'Accept': 'application/json',
            },
        });
        return await rawResponse.json();
    }
    catch (ex) {
        console.error(ex);
        return null;
    }
};
